export interface Review {
  quote: string;
  name: string;
  city: string;
  role: string;
}

export const reviews: Review[] = [{
  quote: 'Organicé toda la temporada en una tarde. Tengo cada sesión pensada para todos mis grupos. Nunca más el domingo de pánico sin saber qué trabajar el lunes.',
  name: 'Sofía M.',
  city: 'Buenos Aires',
  role: 'Entrenadora de Fútbol Femenino en Club Barrial'
}, {
  quote: 'Las sesiones con progresión real por nivel cambiaron todo. Mis jugadoras mejoraron más en 2 meses que en toda la temporada anterior. Y dejaron de abandonar.',
  name: 'Carolina R.',
  city: 'Rosario',
  role: 'DT de Fútbol Femenino Juvenil'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas planificar qué hacer con un grupo heterogéneo de jugadoras.',
  name: 'Valentina F.',
  city: 'Córdoba',
  role: 'Entrenadora de Fútbol Femenino Grupal e Individual'
}];

export const finalReviews: Review[] = [{
  quote: 'La tasa de abandono de mis jugadoras bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual y la variedad de los 7 tomos. Las chicas ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Luciana P.',
  city: 'Tucumán',
  role: 'Entrenadora en Liga Regional Femenina'
}, {
  quote: 'El Tomo 6 de liderazgo me cambió la cabeza. Nunca había dimensionado la importancia del lado humano en un plantel femenino. Ahora gestiono el vestuario con una confianza que antes no tenía.',
  name: 'Marcela G.',
  city: 'Mendoza',
  role: 'DT de Categorías Formativas Femeninas'
}, {
  quote: 'El Megapack Porteras del Pack Elite me sorprendió. Nunca encontré material específico para entrenar arqueras en fútbol femenino. Ahora tengo sesiones listas y mi portera mejoró exponencialmente.',
  name: 'Laura V.',
  city: 'Santa Fe',
  role: 'Entrenadora con enfoque en Arqueras'
}];
